import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    PARABOLIC_ANIMATION_TIME
 } from '../../initials';
export class ParabolicAnimationTopLeftTopRight {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'ParabolicAnimationTopLeftTopRight',
            fromBallPositionByDot: BallPositionByDot.TOP_LEFT,
            toBallPositionByDot: BallPositionByDot.TOP_RIGHT,
        };
    }

    getAnimationTime() {
        const layersCount = this.toRowIndex - this.fromRowIndex;
        return layersCount === 1 ? PARABOLIC_ANIMATION_TIME : PARABOLIC_ANIMATION_TIME * layersCount * 0.5;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;
        const isMostThenOneLevel = this.toRowIndex - this.fromRowIndex > 1;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const middleDot = isLeftMovement ? this.dots[this.fromRowIndex][this.fromDotIndex - 1] : this.dots[this.fromRowIndex][this.fromDotIndex + 1];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, 3 * Math.PI / 4);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, Math.PI / 4);

        return {
            x: parabolic(
                startXY.x, 
                isMostThenOneLevel ? middleDot.dotX : isLeftMovement ? middleDot.dotX + distanceBetweenDots / 2 : middleDot.dotX - distanceBetweenDots / 2, 
                endXY.x, 
                Math.pow(t, 1),
            ),
            y: parabolic(
                startXY.y, 
                isMostThenOneLevel ? middleDot.dotY : middleDot.dotY - distanseBetweenLayers / 2, 
                endXY.y, 
                Math.pow(t, 1),
            ),
        };
    }
}